import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/profile.jpeg"; 
import Tilt from "react-parallax-tilt";
import { AiFillGithub, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.4em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>

            <p className="home-about-body" style={{ lineHeight: 1.6, textAlign: "left" }}>
              Hello! I'm <b className="purple">Ashirwad Sinha</b> from Patna, India.
              <br />
              <br />
              I'm currently pursuing a <b className="purple">Master of Computer Applications (MCA)</b> at Thapar Institute of Engineering & Technology, and I am an upcoming Software Engineer at <b className="purple">Deloitte USI</b>. 
              My core interests lie in <b className="purple">Artificial Intelligence, Deep Learning</b>, and <b className="purple">Computer Vision</b>.
              <br />
              <br />
              I'm highly comfortable with languages and tools like{" "}
              <b className="purple">Python, C/C++, PyTorch, OpenCV, and Pandas</b>. I enjoy building end-to-end machine learning pipelines, deploying interactive applications with <b className="purple">Streamlit and Gradio</b>, and hosting models on <b className="purple">Hugging Face Spaces</b>.
              <br />
              <br />
              Recently, my focus has been on competitive data science and AI hackathons. Some of my notable works include the <b className="purple">DEVision (Driver Gaze) System</b>, <b className="purple">S.E.N.T.I.N.E.L. Drone Analysis</b>, and the <b className="purple">OmniJet Particle Classifier</b>. I thrive on building practical, highly robust AI solutions that solve real-world problems.
            </p>
          </Col>

          <Col md={4} className="myAvtar">
            <Tilt>
              <img
                src={myImg}
                className="img-fluid profile-pic-frame"
                alt="Ashirwad Sinha" 
                style={{ maxHeight: "300px" }}
              />
            </Tilt>
          </Col>
        </Row>

        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect</span> with me
            </p>

            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/ashir1S"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/ashirwad-sinha1"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://www.instagram.com/ashirwadsinha/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;